<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconGuest_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M8 8c1.158 0 2.1-.942 2.1-2.1S9.158 3.8 8 3.8c-1.157 0-2.1.942-2.1 2.1S6.842 8 8 8M11.182 9.906c-.547-.585-1.577-1.019-3.432-1.019-1.87 0-2.902.442-3.445 1.034l-.014.015c-.147.16-.385.418-.484 1.055a.572.572 0 0 0 .565.655h6.757a.572.572 0 0 0 .565-.656c-.1-.644-.344-.905-.502-1.074z"
    />
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-.7 0A6.3 6.3 0 1 1 1.7 8a6.3 6.3 0 0 1 12.6 0"
        clip-rule="evenodd"
    />
</svg>
